import { actionTypes } from '../actions/sharepage';
import isFeedsFast from '../utility/isFeedsFast';
import { isLoadKuaiBao } from '../utility/PageConfigDataForShare';
/*
下载任务状态：
TASK_STATUS_NONE，默认返回值；
TASK_STATUS_CREATED，任务已创建；
TASK_STATUS_STARTED， 任务已开始；
TASK_STATUS_PROGRESS，任务进行中；
TASK_STATUS_COMPLETED，任务已完成；
TASK_STATUS_CANCELED，任务已取消或暂停；
TASK_STATUS_FAILED，任务失败；
TASK_STATUS_TIMEOUT，任务超时；
TASK_STATUS_FILE_HAS_DELETED，下载文件已被删除


downloading:下载中
downloadcanceled: 暂停或者取消
downloaded：下载完成
installed：安装完成

*/
const isFF = isFeedsFast() || false;
let appName = isFF ? '天天快报极速版' : 'QQ浏览器';

export default (state: Object = {}, { type, payload }) => {
  const nextState = {
    downLoadScene: '',
    downLoadStatus: '',
    progressValue: '',
    tagText: `打开${appName}阅读`,
    loadingText: '',
    bannerClass: '',
    currentSlideIndex: '',
    pageConfigData: null, // 接入实验平台配置数据
    ...state,
  };

  function setTagText(downLoadScene, downLoadStatus) {
    let tagText = `打开${appName}阅读`;
    if (downLoadScene) {
      if (downLoadStatus === 'downloading' && downLoadScene === 'bar') {
        tagText = '正在为您加载...';
      }
    }
    return tagText;
  }

  function setLoadingText(downLoadScene, downLoadStatus) {
    // 拉新拉活快报
    if (isLoadKuaiBao()) {
      appName = '看点快报';
    }

    const loadingTextMap = {
      bar: `正在下载${appName}，即将为你打开本条内容`,
      article: `正在下载${appName}，为您优化阅读体验`,
      comment: `正在下载${appName}，为您加载全部评论`,
      recommend: `正在下载${appName}，即可为您打开指定文章`,
      other: `正在下载${appName}，即将为你打开浏览器`,
    };
    let loadingText = `正在下载${appName}，即将为你打开浏览器`;
    if (downLoadScene) {
      if (downLoadStatus === 'downloading') {
        loadingText = loadingTextMap[downLoadScene];
      } else if (downLoadStatus === 'downloadcanceled') {
        loadingText = `已暂停下载${appName}，点击继续`;
      }
    }
    return loadingText;
  }

  function setBannerClass(downLoadScene, downLoadStatus) {
    let bannerClass = '';
    if (downLoadStatus === 'downloading' || downLoadStatus === 'downloadcanceled') {
      bannerClass = downLoadScene === 'bar' ? 'bar-downloading' : 'other-downloading';
    }
    return bannerClass;
  }

  switch (type) {
    case actionTypes.DOWNLOAD_SCENE:
      return {
        ...nextState,
        tagText: setTagText(payload, nextState.downLoadStatus),
        loadingText: setLoadingText(payload, nextState.downLoadStatus),
        bannerClass: setBannerClass(payload, nextState.downLoadStatus),
        downLoadScene: payload,
      };
    case actionTypes.DOWNLOAD_STATUS:
      return {
        ...nextState,
        tagText: setTagText(nextState.downLoadScene, payload),
        loadingText: setLoadingText(nextState.downLoadScene, payload),
        bannerClass: setBannerClass(nextState.downLoadScene, payload),
        downLoadStatus: payload,
      };
    case actionTypes.PROGRESS_VALUE:
      return {
        ...nextState,
        progressValue: `${payload}%`,
      };
    case actionTypes.CRRUENT_SLIDE_INDEX:
      return {
        ...nextState,
        currentSlideIndex: payload,
      };
    case actionTypes.PAGE_CONFIG_DATA:
      return {
        ...nextState,
        pageConfigData: payload,
      };
    default:
      return nextState;
  }
};
